export const categoryMenuItems = [
  { label: "New Arrivals", path: "/collections/new-in" },

  // WOMEN MAIN CATEGORIES
  { label: "Women's Wear", path: "/collections/women" },
  { label: "Kurtas & Sets", path: "/collections/kurtas-sets" },
  { label: "Suits & Anarkalis", path: "/collections/suits" },
  { label: "Dresses", path: "/collections/dresses" },
  // { label: "Sarees", path: "/collections/sarees" },
  { label: "Co-ords", path: "/collections/coord-sets" },
  { label: "Bottomwear", path: "/collections/bottomwear" },
  { label: "Winterwear", path: "/collections/winter" },

  // BEAUTY & WELLNESS
  {
    label: "TaruVeda Organic Shampoo & Oil",
    path: "/taruveda-organic-shampoo-oil",
  },

  
];
